export default __webpack_public_path__ + "static/media/CV.aad0ef39.pdf";